import { Component, OnInit } from '@angular/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-privacy-policy-v1',
  templateUrl: './privacy-policy-v1.component.html'
})
export class PrivacyPolicyV1Component implements OnInit {

  constructor(
    private commonBindingDataService: CommonBindingDataService
  ) { }

  languageOptions: SelectItem[] = [];
  selectedLanguage: any = 'en';
  showLanguageDropdown = false;
  ngOnInit() {
    this.commonBindingDataService.getLanguagesSettings().subscribe((result) => {

      const isLanguageSupport = result.isLanguageSupport === true || result.isLanguageSupport === 'true' ? true : false;

      const supportedLanguages = (result.supportedLanguages).toString();
      this.languageOptions = supportedLanguages
        .split(',')
        .map((c) => c.trim().toLowerCase())
        .filter((c) => c)
        .map((code) => ({ label: AppSettings.LANGUAGE_LABELS[code] ?? code, value: code }));

      const defaultLanguage = (result.defaultLanguage).toString().trim().toLowerCase();
      const supportedLanguageCodes = this.languageOptions.map((opt) => opt.value);
      this.selectedLanguage = supportedLanguageCodes.includes(defaultLanguage) ? defaultLanguage : (supportedLanguageCodes[0] ?? defaultLanguage);

      this.showLanguageDropdown = isLanguageSupport && this.languageOptions.length > 0;
    });

    // const result: any = {
    //   isLanguageSupport: 'true',
    //   supportedLanguages: 'en,fr,de',
    //   defaultLanguage: 'en'
    // }
    // const isLanguageSupport = result.isLanguageSupport === true || result.isLanguageSupport === 'true' ? true : false;

    // const supportedLanguages = (result.supportedLanguages).toString();
    // this.languageOptions = supportedLanguages
    //   .split(',')
    //   .map((c) => c.trim().toLowerCase())
    //   .filter((c) => c)
    //   .map((code) => ({ label: AppSettings.LANGUAGE_LABELS[code] ?? code, value: code }));

    // const defaultLanguage = (result.defaultLanguage).toString().trim().toLowerCase();
    // const supportedLanguageCodes = this.languageOptions.map((opt) => opt.value);
    // this.selectedLanguage = supportedLanguageCodes.includes(defaultLanguage) ? defaultLanguage : (supportedLanguageCodes[0] ?? defaultLanguage);

    // this.showLanguageDropdown = isLanguageSupport && this.languageOptions.length > 0;
  }

}
